<template>
  <html>
    <head>
      <meta charset="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <!-- <link rel="icon" href="img/favicon.ico">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" type="text/css">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/font-awesome.min.css" type="text/css">
  <link rel="stylesheet" href="theme.css" type="text/css"> -->
      <title>Porto - Portal de Autonegociação</title>
    </head>

    <body>
      <!-- ========== NOVO LAYOUT LANDING (imagem desktop/mobile como FormDocNumber) ========== -->
      <template v-if="!notExists">
        <!-- Desktop largo (>= 1200px): imagem à esquerda, card à direita, fundo #0046C0 -->
        <div
          v-if="largura >= 1200"
          class="landing-new-desktop"
        >
          <div class="landing-new-left">
            <img
              class="landing-new-hero-img"
              src="/img/image-mobile.png?v=2611"
              alt=""
            />
          </div>
          <div class="landing-new-right">
            <div class="card shadow-sm landing-new-card">
              <div class="card-body px-4 py-4">
                <h4 class="">Olá, {{ accessname }}<br /></h4>
                <h5 class="text-muted">Preencha os campos abaixo</h5>
                <h6 class="text-body mb-1">CPF / CNPJ</h6>
                <p class="text-muted text-left small mb-1">Digite os 4 primeiros números. Por segurança, digite apenas os 4 primeiros dígitos do seu CPF ou CNPJ:</p>
                <form v-on:submit="dologin" v-on:submit.prevent id="form">
                  <div class="input-group mb-3">
                    <input type="text" aria-label="cpf-cnpj" class="form-control" v-model="form.accessdoc" :disabled="loading" v-mask="['####']" />
                    <div class="input-group-append d-flex justify-content-start">
                      <span class="input-group-text landing-input-group-text text-left" id="basic-addon">xx.xxx-xx ou x.xxx/xxxx-xx</span>
                    </div>
                  </div>
                  <div class="form-group mb-2">
                    <p class="text-left small mb-1 text-muted">Digite o código de acesso que recebeu:</p>
                    <input type="text" class="form-control" placeholder="Código de acesso" id="form" v-model="form.accesscode" :disabled="loading" />
                  </div>
                  <div v-if="promoCodeErrors.length" style="text-align: left; font-size: 11px">
                    <b v-for="error in promoCodeErrors" v-bind:key="error" v-bind:class="classMessage" class="form-text">{{ error }}</b>
                  </div>
                  <button v-if="!loading" type="submit" class="btn btn-primary btn-lg d-flex my-4 mx-auto text-white" style="border-radius: 6px; background-color: #0046C0; border-color: #0046C0;">Prosseguir</button>
                  <div class="mt-3"><ProgressLoading v-bind:loading="loading" /></div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop estreito / vertical (501–1199px): imagem em cima, card abaixo, centralizado -->
        <div
          v-if="largura >= 501 && largura < 1200"
          style="background-color: #0046C0; min-height: 100vh; padding: 1.5rem; display: flex; flex-direction: column; align-items: center; justify-content: center;"
        >
          <div class="landing-stacked-block" style="max-width: 420px; width: 100%; margin: 0 auto; box-sizing: border-box;">
            <div style="border-radius: 12px 12px 0 0; overflow: hidden; width: 100%;">
              <img src="/img/image-mobile.png?v=2611" alt="" class="landing-stacked-img" style="width: 100%; max-width: 100%; height: auto; max-height: 45vh; object-fit: cover; object-position: center top; display: block; margin: 0; padding: 0;" />
            </div>
            <div class="card shadow-sm landing-new-card" style="width: 100%; margin-top: 0; border: none; border-radius: 0 0 24px 24px; box-sizing: border-box;">
              <div class="card-body px-4 py-4">
                <h4 class="">Olá, {{ accessname }}<br /></h4>
                <h5 class="text-muted">Preencha os campos abaixo</h5>
                <h6 class="text-body mb-1">CPF / CNPJ</h6>
                <p class="text-muted text-left small mb-1">Digite os 4 primeiros números. Por segurança, digite apenas os 4 primeiros dígitos do seu CPF ou CNPJ:</p>
                <form v-on:submit="dologin" v-on:submit.prevent id="form">
                  <div class="input-group mb-3">
                    <input type="text" aria-label="cpf-cnpj" class="form-control" v-model="form.accessdoc" :disabled="loading" v-mask="['####']" />
                    <div class="input-group-append d-flex justify-content-start">
                      <span class="input-group-text landing-input-group-text text-left" id="basic-addon">xx.xxx-xx ou x.xxx/xxxx-xx</span>
                    </div>
                  </div>
                  <div class="form-group mb-2">
                    <p class="text-left small mb-1 text-muted">Digite o código de acesso que recebeu:</p>
                    <input type="text" class="form-control" placeholder="Código de acesso" id="form" v-model="form.accesscode" :disabled="loading" />
                  </div>
                  <div v-if="promoCodeErrors.length" style="text-align: left; font-size: 11px">
                    <b v-for="error in promoCodeErrors" v-bind:key="error" v-bind:class="classMessage" class="form-text">{{ error }}</b>
                  </div>
                  <button v-if="!loading" type="submit" class="btn btn-primary btn-lg d-flex my-4 mx-auto text-white" style="border-radius: 6px; background-color: #0046C0; border-color: #0046C0;">Prosseguir</button>
                  <div class="mt-3"><ProgressLoading v-bind:loading="loading" /></div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- Mobile (<= 500px): card em cima, imagem abaixo (mesmo padrão do Login) -->
        <div
          v-if="largura <= 500"
          class="landing-new-mobile"
          style="min-height: 100vh; background-color: #0046C0; display: flex; flex-direction: column; align-items: center; box-sizing: border-box; width: 100%; max-width: 100vw; margin-left: auto; margin-right: auto; padding: 2rem 1.25rem 1.5rem 1.25rem;"
        >
          <div class="landing-mobile-block" style="max-width: 420px; width: 100%; box-sizing: border-box;">
            <div class="card landing-new-card landing-mobile-card" style="margin-bottom: 0; border: none; border-radius: 12px 12px 0 0; width: 100%; box-sizing: border-box; box-shadow: none;">
              <div class="card-body px-4 py-4">
                <h4 class="">Olá, {{ accessname }}<br /></h4>
                <h5 class="text-muted">Preencha os campos abaixo</h5>
                <h6 class="text-body mb-1">CPF / CNPJ</h6>
                <p class="text-muted text-left small mb-1">Digite os 4 primeiros números. Por segurança, digite apenas os 4 primeiros dígitos do seu CPF ou CNPJ:</p>
                <form v-on:submit="dologin" v-on:submit.prevent id="form">
                  <div class="input-group mb-3">
                    <input type="text" aria-label="cpf-cnpj" class="form-control" v-model="form.accessdoc" :disabled="loading" v-mask="['####']" />
                    <div class="input-group-append d-flex justify-content-start">
                      <span class="input-group-text landing-input-group-text text-left" id="basic-addon">xx.xxx-xx ou x.xxx/xxxx-xx</span>
                    </div>
                  </div>
                  <div class="form-group mb-2">
                    <p class="text-left small mb-1 text-muted">Digite o código de acesso que recebeu:</p>
                    <input type="text" class="form-control" placeholder="Código de acesso" id="form" v-model="form.accesscode" :disabled="loading" />
                  </div>
                  <div v-if="promoCodeErrors.length" style="text-align: left; font-size: 11px">
                    <b v-for="error in promoCodeErrors" v-bind:key="error" v-bind:class="classMessage" class="form-text">{{ error }}</b>
                  </div>
                  <button
                    v-if="!loading"
                    type="submit"
                    class="btn btn-primary btn-lg d-flex my-4 mx-auto text-white"
                    style="border-radius: 6px; background-color: #0046C0; border-color: #0046C0;"
                  >
                    Prosseguir
                  </button>
                  <div v-else class="landing-card-loading">
                    <ProgressLoading v-bind:loading="loading" />
                  </div>
                </form>
              </div>
            </div>
            <img
              src="/img/image-mobile.png?v=2611"
              alt=""
              class="landing-mobile-img-below"
              style="display: block; width: 100%; border-radius: 0 0 12px 12px; object-fit: cover; object-position: center;"
            />
          </div>
        </div>
      </template>
      <div v-else class="capa1" style="">
        <div class="container">
          <div class="text-center">
            <h2 style="color: #fff;">Link de acesso vencido! Por favor, use um link válido.</h2>
          </div>
        </div>
      </div>

      <!-- ========== LAYOUT ANTIGO (desativado – para reativar, trocar v-if e exibir este bloco) ========== -->
      <div v-if="false" class="capa1" style="">
        <div class="container">
          <div class="row" v-if="!notExists">
            <div class="pt-4 col-lg-5">
              <h1 class="pl-0 text-white col-1 d-none d-lg-block mt-5 col-lg-12" style="">Negocie suas dívidas para você ficar no azul!</h1>
            </div>
            <div class="col-md-6 col-12 col-sm-10 col-lg-4">
              <div class="mx-auto bg-light p-3 lpp4">
                <div class="border-top-0 py-3 px-3">
                  <h4 class="">Olá, {{ accessname }}<br /></h4>
                  <h5 class="text-muted">Preencha os campos abaixo</h5>
                  <h6>
                    CPF / CNPJ
                    <span class="badge badge-light">
                      Digite os 4 primeiros números</span
                    >
                  </h6>
                  <p class="text-muted text-left small mb-1">
                    Por segurança, digite apenas os 4 primeiros dígitos do seu
                    CPF ou CNPJ:
                  </p>
                  <form v-on:submit="dologin" v-on:submit.prevent id="form">
                    <div class="input-group mb-3">
                      <input
                        type="text"
                        aria-label="cpf-cnpj"
                        aria-describedby="basic-addon"
                        class="form-control"
                        v-model="form.accessdoc"
                        :disabled="loading"
                        v-mask="['####']"
                      />
                      <div
                        class="input-group-append d-flex justify-content-start"
                      >
                        <span
                          class="input-group-text text-left"
                          id="basic-addon"
                          >xx.xxx-xx ou x.xxx/xxxx-xx</span
                        >
                      </div>
                    </div>
                    <div class="form-group mb-2">
                      <p class="text-left small mb-1 text-muted">
                        Digite o código de acesso que recebeu:
                      </p>
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Código de acesso"
                        id="form"
                        label="Digite"
                        v-model="form.accesscode"
                        :disabled="loading"
                      />
                    </div>
                    <div class="col-md-8" style="padding: 0px">
                      <div
                        v-if="promoCodeErrors.length"
                        style="text-align: left; font-size: 11px"
                      >
                        <b
                          v-for="error in promoCodeErrors"
                          v-bind:key="error"
                          v-bind:class="classMessage"
                          class="form-text"
                          >{{ error }}</b
                        >
                      </div>
                    </div>
                    <button
                      v-if="!loading"
                      type="submit"
                      class="btn btn-primary btn-lg d-flex my-4 mx-auto text-white"
                    >
                      Prosseguir
                    </button>
                  </form>
                  <div class="mt-3">
                    <ProgressLoading v-bind:loading="loading" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center" v-else>
            <h2 style="color: #fff;">Link de acesso vencido! Por favor, use um link válido.</h2>
          </div>
        </div>
      </div>

      <div class="sec10 bg-light">
        <div class="container">
          <div class="row justify-content-center text-center mb-5">
            <div class="col-md-12 text-dark">
              <h2 class="py-4">
                Como fazer a negociação online do seu Cartão de Crédito Porto
                Bank
              </h2>
            </div>
          </div>
          <div class="row d-flex justify-content-center text-dark">
            <div class="col-6 col-lg-3 p-2 pl-3 pr-4">
              <img class="img-fluid d-block mb-3" src="/img/ic01.jpg" />
              <h5>Identifique-se fazendo o login.</h5>
            </div>
            <div class="col-6 col-lg-3 p-2 pr-4 pl-3">
              <img class="img-fluid d-block mb-3" src="/img/ic02.jpg" />
              <h5>Selecione a melhor opção para você.</h5>
            </div>
            <div class="col-6 col-lg-3 p-2 pr-4 pl-3">
              <img class="img-fluid d-block mb-3" src="/img/ic03.jpg" />
              <h5 class="">Gere o boleto e faça o pagamento.</h5>
            </div>
            <div class="col-6 col-lg-3 p-2 pr-4 pl-3">
              <img class="img-fluid d-block mb-3" src="/img/ic04.jpg" />
              <h5 class="">Pronto! Tudo certo com a sua negociação.</h5>
            </div>
          </div>
        </div>
      </div>

      <section class="bg-light py-3">
        <div class="container py-5">
          <div class="row">
            <div class="col-11 mx-auto">
              <h4>
                Tire suas dúvidas sobre a Negociação de Dívidas
                <hr style="border-color: #fff" />
              </h4>
              <div class="accordion" id="faq">
                <div class="card">
                  <div class="card-header p-2" id="headingOne">
                    <h5 class="mb-0">
                      <button
                        class="btn-link"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse1"
                        aria-expanded="true"
                        aria-controls="collapse1"
                        style="font-size: 16px"
                      >
                        O que é a negociação de dívidas?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse1"
                    class="collapse"
                    aria-labelledby="heading1"
                  >
                    <div class="card-body px-4">
                      Negociação de dívidas é uma maneira de
                      <strong>simplificar a quitação</strong> das suas dívidas com
                      nossos produtos financeiros.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header p-2" id="heading2">
                    <h5 class="mb-0">
                      <button
                        class="btn-link collapsed"
                        type="button"
                        aria-expanded="false"
                        data-target="#collapse2"
                        aria-controls="collapse2"
                        data-toggle="collapse"
                        style="font-size: 16px"
                      >
                        De que forma posso pagar a negociação do cartão de
                        crédito?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse2"
                    class="collapse"
                    aria-labelledby="heading2"
                  >
                    <div class="card-body px-4">
                      Você pode pagar sua negociação de cartão de crédito por meio
                      de <strong>boleto bancário</strong> ou <strong>Pix</strong>
                      pelo nosso <strong>Portal de Negociação</strong>,
                      <strong>App Porto</strong> ou
                      <strong>WhatsApp Oficial</strong>.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header p-2" id="heading3">
                    <h5 class="mb-0">
                      <button
                        class="btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse3"
                        aria-expanded="false"
                        aria-controls="collapse3"
                        style="font-size: 16px"
                      >
                        Quanto tempo leva, após o pagamento, para sair das
                        restrições de crédito?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse3"
                    class="collapse"
                    aria-labelledby="heading3"
                  >
                    <div class="card-body px-4">
                      Depois que você pagar a negociação, seu nome será removido
                      das restrições de crédito em até
                      <strong>5 dias úteis</strong>.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header p-2" id="heading4">
                    <h5 class="mb-0">
                      <button
                        class="btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse4"
                        aria-expanded="false"
                        aria-controls="collapse4"
                        style="font-size: 16px"
                      >
                        Como posso emitir uma segunda via de boleto de
                        negociação?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse4"
                    class="collapse"
                    aria-labelledby="heading4"
                  >
                    <div class="card-body px-4">
                      <p class="mb-2">
                        <strong>Para cartão de crédito:</strong> Acesse o portal,
                        App ou WhatsApp Oficial e emita a segunda via do boleto.
                      </p>
                      <p class="mb-0">
                        <strong>Para outros produtos:</strong> Entre em contato
                        com a central de atendimento para solicitar a segunda via.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header p-2" id="heading5">
                    <h5 class="mb-0">
                      <button
                        class="btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse5"
                        aria-expanded="false"
                        aria-controls="collapse5"
                        style="font-size: 16px"
                      >
                        Qual é o prazo para pagamento do boleto da negociação?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse5"
                    class="collapse"
                    aria-labelledby="heading5"
                  >
                    <div class="card-body px-4">
                      Você tem <strong>até 15 dias</strong> para pagar o boleto da
                      negociação de dívida.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header p-2" id="heading6">
                    <h5 class="mb-0">
                      <button
                        class="btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse6"
                        aria-expanded="false"
                        aria-controls="collapse6"
                        style="font-size: 16px"
                      >
                        Tenho condições especiais para negociar as minhas
                        dívidas?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse6"
                    class="collapse"
                    aria-labelledby="heading6"
                  >
                    <div class="card-body px-4">
                      <strong>Sim, você pode ter condições especiais</strong>!
                      Faça o login e acesse nossa página para conferir as
                      condições de negociação.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header p-2" id="heading7">
                    <h5 class="mb-0">
                      <button
                        class="btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse7"
                        aria-expanded="false"
                        aria-controls="collapse7"
                        style="font-size: 16px"
                      >
                        O que é o Desenrola 2.0?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse7"
                    class="collapse"
                    aria-labelledby="heading7"
                  >
                    <div class="card-body px-4">
                      O <strong>Desenrola 2.0</strong> é um
                      <strong>programa do Governo Federal Brasileiro</strong> para
                      renegociação de dívidas de famílias, estudantes e empresas com
                      condições diferenciadas.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header p-2" id="heading8">
                    <h5 class="mb-0">
                      <button
                        class="btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse8"
                        aria-expanded="false"
                        aria-controls="collapse8"
                        style="font-size: 16px"
                      >
                        Quem está elegível ao Desenrola 2.0?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse8"
                    class="collapse"
                    aria-labelledby="heading8"
                  >
                    <div class="card-body px-4">
                      Estão elegíveis ao <strong>Desenrola 2.0</strong> quem possui
                      renda mensal de
                      <strong>até 5 salários mínimos</strong> (até R$ 8.105),
                      <strong>atraso entre 90 e 2 anos</strong> e o
                      <strong>limite da nova dívida</strong> (após os descontos)
                      <strong>de até R$ 15 mil</strong> por pessoa, por instituição
                      bancária.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header p-2" id="heading9">
                    <h5 class="mb-0">
                      <button
                        class="btn-link collapsed"
                        type="button"
                        data-toggle="collapse"
                        data-target="#collapse9"
                        aria-expanded="false"
                        aria-controls="collapse9"
                        style="font-size: 16px"
                      >
                        Como negociar dívidas no Desenrola 2.0?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapse9"
                    class="collapse"
                    aria-labelledby="heading9"
                  >
                    <div class="card-body px-4">
                      Acesse nossos
                      <strong>canais oficiais de negociação</strong> (Portal de
                      Negociação, App Porto ou WhatsApp Oficial), se identifique e
                      aproveite as condições.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </body>
  </html>
</template>

<script>
import { mapActions } from "vuex";
import { mask } from "vue-the-mask";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ProgressLoading from "../../modules/auth/components/ProgressLoading.vue";
import { ActionGetIPAddress } from "@/utils/helpers";

export default {
  components: {
    ProgressLoading,
  },
  name: "Landing",
  directives: { mask },
  mixins: [validationMixin],
  validations: {
    form: {
      accessdoc: { required, minLength: minLength(4) },
    },
  },
  data: () => ({
    themeBackground: null,
    imageBackground: null,
    form: {
      accessdoc: null,
      accesscode: null,
      termsAcepted: false,
    },
    error: {
      alert: false,
      status: null,
      message: null,
    },
    accessname: "",
    loading: false,
    notExists: false,
    largura: null,
    ipUser: null,
  }),
  methods: {
    ...mapActions("auth", [
      "ActionGetMailingFirstName",
      "ActionMailingDoLogin",
    ]),
    async dologin() {
      this.promoCodeErrors.pop();
      this.loading = true;
      this.promoCodeErrors.pop();
      this.error.status = "ERROR";
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.loading = false;
        return;
      } else {
        this.loading = true;
        try {
          await this.ActionMailingDoLogin({
            DocNumber: this.form.accessdoc,
            AccessCode: this.form.accesscode,
            DeviceName: process.env.VUE_APP_API_DEVICE,
            IP: this.ipUser ? this.ipUser : "",
            OS:navigator.platform,
          });
          this.loading = false;
          location.href = "/";
        } catch (error) {
          this.promoCodeErrors.push(
            "CPF/CNPJ ou código de acesso incorretos"
          );
          this.error.status = "ERROR";
          this.loading = false;
        }
        this.loading = false;
      }
    },

    async getIPAddressUser() {
      let maxAttempts = 10;
      let attempts = 0;

      while (attempts < maxAttempts) {
        try {
          this.ipUser = await ActionGetIPAddress();
          break; // Saia do loop se o IP for obtido com sucesso
        } catch (error) {
          console.log("Erro ao obter o endereço IP. Tentando novamente...");
          attempts++;
          await new Promise((resolve) => setTimeout(resolve, 1000)); // Aguarde 1 segundo antes de tentar novamente
        }
      }

      if (attempts === maxAttempts) {
        console.log(
          "Número máximo de tentativas atingido. Não foi possível obter o endereço IP."
        );
      }
    },
  },
  async created() {
    this.largura = typeof window !== "undefined" ? window.innerWidth : 0;
    await this.getIPAddressUser();
    this.loading = true;
    this.form.accesscode = this.$route.params.mailing;

    var result = await this.ActionGetMailingFirstName({
      AccessCode: this.form.accesscode,
      IP: this.ipUser ? this.ipUser : "",
      OS: navigator.platform,
    });
    if (result.data.code !== 200) {
      this.notExists = true;
      this.loading = false;
    } else {
      this.accessname = result.data.results.FirstName;
    }
    this.loading = false;
  },
  mounted() {
    this.largura = window.innerWidth;
    const onResize = () => {
      this.largura = window.innerWidth;
    };
    window.addEventListener("resize", onResize);
    this._landingResizeHandler = onResize;
  },
  beforeDestroy() {
    if (this._landingResizeHandler) {
      window.removeEventListener("resize", this._landingResizeHandler);
    }
  },
  computed: {
    promoCodeErrors() {
      const errors = [];

      if (!this.$v.form.accessdoc.$dirty) return errors;
      !this.$v.form.accessdoc.required && errors.push("Campo é obrigatório!");
      !this.$v.form.accessdoc.minLength &&
        errors.push("O CPF/CNPJ não está completo!");

      return errors;
    },
    classMessage: function () {
      return {
        "text-danger": this.error.status == "ERROR",
        "text-muted": !this.error.status == "ERROR",
      };
    },
  },
};
</script>

<style>
/* FAQ: perguntas do acordeão em azul Porto */
#faq .card .btn-link {
  color: #0046c0 !important;
}
#faq .card .btn-link:hover,
#faq .card .btn-link:focus {
  color: #00389a !important;
}

/* Landing desktop: painel da arte ~1:1 (igual à imagem) + cover sem faixas */
.landing-new-desktop {
  background-color: #0046c0;
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: stretch;
  box-sizing: border-box;
}

.landing-new-left {
  flex: 0 0 auto;
  width: min(56vw, 100vh);
  max-width: 62%;
  min-width: 0;
  position: relative;
  overflow: hidden;
  background-color: #0046c0;
}

.landing-new-hero-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  display: block;
}

.landing-new-right {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.5rem;
  box-sizing: border-box;
  background-color: #0046c0;
}

.landing-new-card {
  border: none !important;
  border-radius: 12px 12px 24px 24px !important;
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
  flex: 0 1 420px;
}

/* Landing mobile: mesmas margens e bloco card+imagem do Login */
.landing-new-mobile {
  width: 100% !important;
  max-width: 100vw !important;
  margin-left: auto !important;
  margin-right: auto !important;
  box-sizing: border-box !important;
}

.landing-mobile-block {
  width: 100%;
  max-width: 420px;
  margin-left: auto;
  margin-right: auto;
}

.landing-mobile-block .card,
.landing-mobile-block img {
  margin-left: 0 !important;
  margin-right: 0 !important;
  max-width: 100%;
}

.landing-mobile-card,
.landing-mobile-card.card {
  border: none !important;
  border-bottom: none !important;
  box-shadow: none !important;
}

.landing-mobile-card .card-body {
  border-bottom: none !important;
  padding-bottom: 1.5rem !important;
}

.landing-mobile-img-below {
  display: block;
  width: 100%;
}

.landing-card-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 52px;
  margin: 1.5rem 0;
}
</style>